export const fonts = {
  "source-code": ["Source Code Pro, ", "monospace"],
  poppins: ["Poppins, ", "sans-serif"],
  "short-stack": ["Short Stack, ", "cursive"],
  apropal: ["Apropal, ", "serif"],
  "victor-mono-oblique": ["Victor Mono, ", "monospace"]
};